export default "__VITE_ASSET__DE6UKkk3__"